import { ROLES } from 'config/roles';
import { ROUTE_PATH } from 'config/routes';
import { GrCertificate } from 'react-icons/gr';
import { BiHomeAlt } from 'react-icons/bi';
import {
  DocumentPlusIcon,
  DocumentSearchIcon,
} from '@grupoboticario/flora-react-icons';

interface IMenu {
  path: string;
  name: string;
  icon?: any;
  roles: string[];
}
export const MENU: IMenu[] = [
  {
    path: ROUTE_PATH.HOME,
    name: 'Sinistros',
    icon: <BiHomeAlt />,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: ROUTE_PATH.CERTIFICATES,
    name: 'Declarações',
    icon: <GrCertificate />,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO_CERTIFICADO],
  },
  {
    path: ROUTE_PATH.REPORTS,
    name: 'Relatórios',
    icon: <DocumentPlusIcon size={18} />,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO_CERTIFICADO],
  },
  {
    path: ROUTE_PATH.KNOWLEDGE_PORTAL,
    name: 'Portal do Conhecimento',
    icon: <DocumentSearchIcon size={18} />,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
];
